import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from './serviceWorker';

import App from './App';
import store from './store';

import "./index.css";

const app = (
    <Provider store={store}>
        <BrowserRouter basename='/org'>
            <App />
        </BrowserRouter>
    </Provider>
)
ReactDOM.render(app,
    document.getElementById('root'));

serviceWorker.register();

export default store;